import type { ComponentProps } from "react"
import {
  SheetPortal,
  SheetContent as SheetContentBase,
} from "@/v2-ui/sheet/base/SheetBase"
import SheetOverlay from "@/v2-ui/sheet/SheetOverlay"
import { useQuerySelectorLazy } from "@/v2-ui/utils/utils.dom"
import cn from "@/v2-ui/utils/utils.cn"

const DEAFAULT_PORTAL_CONTAINER = "#mount"

export type SheetContentProps = ComponentProps<typeof SheetContentBase> & {
  portalContainer?: string
  showOverlay?: boolean
  /** When false, disables open/close animations on both the content and overlay. Defaults to true. */
  isAnimated?: boolean
  /** When false, clicking outside the sheet will not close it. Defaults to true. */
  closeOnOutsideClick?: boolean
}

function SheetContent(props: SheetContentProps) {
  const {
    portalContainer = DEAFAULT_PORTAL_CONTAINER,
    showOverlay = true,
    isAnimated = true,
    closeOnOutsideClick = true,
    className,
    onInteractOutside,
    ...sheetContentBaseProps
  } = props

  const portalElem = useQuerySelectorLazy(portalContainer)

  return (
    <SheetPortal container={portalElem}>
      {showOverlay ? (
        <SheetOverlay
          className={isAnimated ? undefined : "ui-sheet-no-animation"}
        />
      ) : null}
      <SheetContentBase
        className={cn(
          "ui-sheet-content",
          !isAnimated && "ui-sheet-no-animation",
          className,
        )}
        onInteractOutside={(event) => {
          if (!closeOnOutsideClick) {
            event.preventDefault()
          }
          onInteractOutside?.(event)
        }}
        {...sheetContentBaseProps}
      />
    </SheetPortal>
  )
}

export default SheetContent
